import { PATCH } from "../../APiHelper/API";

export const updateTeamToNewStadium = (team_id, new_stadium_id, onSuccess, onError) => {
    const data = {
        new_stadium_id: new_stadium_id
    }
    PATCH(`/api/v1/leagues/team/${team_id}/update_stadium`, data, onSuccess, onError)
}